var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"height":"100vh"}},[_c('iframe',{attrs:{"src":_vm.src,"width":"100%","height":"1500px","scrolling":"no","frameborder":"0"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }